module.exports = __webpack_public_path__ + "media/images/salomon_banner/banner__sponsor__sidebar--right-80e5eef9b8e4d607b4169cbf38f6e81d.jpg";